import { closeDialog, useAppDispatch } from '@fly/store';

import { DistributionConfirmation } from '../DistributionConfirmation/DistributionConfirmation';
import { type DistributionFormRow } from './distributionFormKeys';

export interface DistributionConfirmationDialogContentProps {
  row: DistributionFormRow;
  reopenDistributionDialog?: () => void;
}

export function DistributionConfirmationDialogContent({
  row,
  reopenDistributionDialog,
}: DistributionConfirmationDialogContentProps) {
  const dispatch = useAppDispatch();

  const closeConfirmationDialog = () => {
    dispatch(closeDialog());
    reopenDistributionDialog?.();
  };

  return (
    <DistributionConfirmation
      distributeRow={row}
      onCancel={closeConfirmationDialog}
      onDistributeComplete={closeConfirmationDialog}
    />
  );
}
